import round from './round'

function calcularIMC(peso, altura) {
    return plausibleResult(round(Number(peso) / (Number(altura) * Number(altura)) * 10000))
}

function plausibleResult(number) {
    if (number > 5 && number < 150) {
        return number
    } else {
        return null
    }
}

function calcularIdeal(sexo, altura) {
    if (sexo === "Masc") {
        return plausibleResult(round(altura - 100))
    } else if (sexo === "Fem") {
        return plausibleResult(round(altura - 105))
    } else {
        return null
    }
}

function calcularAjustado(sexo, peso, altura) {
    if (sexo === "Masc") {
        return plausibleResult(round((altura - 100) + 0.4 * (peso - (altura - 100))))
    } else if (sexo === "Fem") {
        return plausibleResult(round((altura - 105) + 0.4 * (peso - (altura - 105))))
    } else {
        return null
    }
}

function calcularPredito(sexo, altura) {
    if (sexo === "Masc") {
        return plausibleResult(round(50 + 0.91 * (altura - 152.4)))
    } else if (sexo === "Fem") {
        return plausibleResult(round(45.5 + 0.91 * (altura - 152.4)))
    } else {
        return null
    };
}


function formatarData(date) {
    // Verifica se a data de nascimento foi fornecida
    if (date === undefined) return '';

    // Remove caracteres não numéricos e limita a 8 dígitos
    date = date.replace(/\D/g, '').slice(0, 8);

    // Aplica a formatação DD/MM/AAAA conforme o tamanho da entrada
    const dataFormatada = date.replace(
        /^(\d{2})(\d{2})?(\d{4})?$/,
        (_, p1, p2, p3) => [p1, p2, p3].filter(Boolean).join('/')
    );

    if (dataFormatada.length !== 10) {
        return dataFormatada
    } else {

    return `${dataFormatada}`;
        }
    }


function calcularIdade(dataNascimento) {
    if (dataNascimento.length !== 10) {
        return ""
    }
    // Verifica se a data está no formato correto (DD/MM/AAAA)
    if (!/^\d{2}\/\d{2}\/\d{4}$/.test(dataNascimento)) {
        return "";
    }

    // Separa os valores de dia, mês e ano
    const [dia, mes, ano] = dataNascimento.split('/').map(Number);

    // Cria um objeto Date para a data de nascimento
    const dataNasc = new Date(ano, mes - 1, dia);
    const hoje = new Date();

    // Valida se a data é real (evita casos como 31/02/2023)
    if (
        dataNasc.getDate() !== dia ||
        dataNasc.getMonth() !== mes - 1 ||
        dataNasc.getFullYear() !== ano
    ) {
        return "";
    }

    // Impede datas futuras
    if (dataNasc > hoje) {
        return "";
    }

    if (
        dataNasc.getFullYear() < 1900
    ) {
        return "";
    }

    // Calcula a idade em anos
    let idadeEmAnos = hoje.getFullYear() - dataNasc.getFullYear();

    // Ajusta caso o aniversário ainda não tenha ocorrido neste ano
    if (
        hoje.getMonth() < dataNasc.getMonth() ||
        (hoje.getMonth() === dataNasc.getMonth() && hoje.getDate() < dataNasc.getDate())
    ) {
        idadeEmAnos--;
    }

    // Calcula os meses de diferença
    let idadeEmMeses = hoje.getMonth() - dataNasc.getMonth() + (hoje.getFullYear() - dataNasc.getFullYear()) * 12;

    // Se a idade for menor que 1 ano, retorna a idade em meses
    if (idadeEmAnos < 1) {
        return `${idadeEmMeses} mes${idadeEmMeses === 1 ? '' : 'es'}`;
    }

    // Se a idade for menor que 2 anos, retorna a idade em anos e meses
    if (idadeEmAnos < 2) {
        const meses = hoje.getMonth() - dataNasc.getMonth() + (hoje.getFullYear() - dataNasc.getFullYear()) * 12;
        const anos = Math.floor(meses / 12);
        const mesesRestantes = meses % 12;
        return `${anos} ano${mesesRestantes > 0 ? ` e ${mesesRestantes} mês${mesesRestantes === 1 ? '' : 'es'}` : ''}`;
    }

    // Retorna a idade em anos
    return `${idadeEmAnos} anos`;
}


export { calcularIMC, calcularIdeal, calcularAjustado, calcularPredito, formatarData, calcularIdade }
